'use client';

import { V2Layout, RevealSection, useV2Lang, Rule, HAIRLINE, PageHeader, Eyebrow } from '../../_layout';

const COPY = {
  CN: {
    kicker: '使用条款', title: '使用条款',
    lede: '本网站由 PathIN e.V. 运营。访问或使用本网站即表示同意以下条款。',
    sections: [
      { t: '1. 内容版权', b: '本网站文字、图片、音视频内容如无另外标注，著作权归 PathIN e.V. 或相应作者 / 艺术家所有。仅在保留出处和不作商业用途的前提下可转载。' },
      { t: '2. 引用与转载', b: '欢迎媒体、研究者、教育用途引用本网站内容，请保留来源链接（pathin.eu）和创作者署名。商业再使用请先来信 pathin@pathin.eu。' },
      { t: '3. 链接到第三方', b: '本网站可能链接到第三方网站（艺人页面、票务平台、合作机构等）。这些链接仅供方便。我们不对其内容、隐私实践或可用性负责。' },
      { t: '4. 用户提交', b: '通过联系表单或邮件提交的内容仅用于回复您本人。我们不公开您的个人信息。' },
      { t: '5. 适用法律', b: '本条款适用德意志联邦共和国法律。争议管辖法院为慕尼黑。' },
    ],
  },
  EN: {
    kicker: 'Terms', title: 'Terms of use',
    lede: 'This website is operated by PathIN e.V. Using it constitutes acceptance of the terms below.',
    sections: [
      { t: '1. Copyright', b: "Unless otherwise marked, the text, images, audio and video content on this site is copyright PathIN e.V. or the respective creator. Reuse permitted only with attribution and non-commercial intent." },
      { t: '2. Citation & reuse', b: "Press, researchers, and educational uses are welcome to cite content. Please keep the source link (pathin.eu) and credit the original author. Commercial reuse requires prior email to pathin@pathin.eu." },
      { t: '3. External links', b: "This site may link to third-party websites (artist pages, ticketing, partner institutions). These links are for convenience. We are not responsible for their content, privacy practices, or availability." },
      { t: '4. Submitted content', b: 'Content sent via contact form or email is used only to reply to you. We do not publish your personal information.' },
      { t: '5. Governing law', b: 'These terms are governed by the law of the Federal Republic of Germany. Place of jurisdiction is Munich.' },
    ],
  },
  DE: {
    kicker: 'Nutzungsbedingungen', title: 'Nutzungsbedingungen',
    lede: 'Diese Website wird von PathIN e.V. betrieben. Mit der Nutzung der Seite akzeptieren Sie die folgenden Bedingungen.',
    sections: [
      { t: '1. Urheberrecht', b: 'Soweit nicht anders gekennzeichnet, sind Texte, Bilder, Audio- und Videoinhalte dieser Seite urheberrechtlich geschützt durch PathIN e.V. oder die jeweiligen Urheber:innen. Weiterverwendung nur mit Quellenangabe und zu nichtkommerziellen Zwecken.' },
      { t: '2. Zitat & Weiterverwendung', b: 'Presse, Forschung und Bildung dürfen Inhalte zitieren. Bitte den Quellenlink (pathin.eu) erhalten und Urheber:innen nennen. Kommerzielle Weiterverwendung erfordert vorherige Anfrage an pathin@pathin.eu.' },
      { t: '3. Externe Links', b: 'Diese Seite kann auf externe Websites verlinken (Künstler:innen-Seiten, Ticketing, Partnerinstitutionen). Diese Links dienen nur dem Komfort. Wir sind nicht verantwortlich für deren Inhalte, Datenschutzpraxis oder Verfügbarkeit.' },
      { t: '4. Eingesendete Inhalte', b: 'Inhalte aus dem Kontaktformular oder per E-Mail werden nur zur Beantwortung verwendet. Wir veröffentlichen keine personenbezogenen Daten.' },
      { t: '5. Anwendbares Recht', b: 'Diese Bedingungen unterliegen dem Recht der Bundesrepublik Deutschland. Gerichtsstand ist München.' },
    ],
  },
};

export default function V2Terms() {
  const lang = useV2Lang();
  const t = COPY[lang];
  return (
    <V2Layout hideFooterContact>
      <PageHeader kicker={t.kicker} title={t.title} lede={t.lede} />
      <Rule />
      <RevealSection className="px-6 md:px-10 py-16">
        <div className="mx-auto max-w-[800px] divide-y" style={{ borderColor: HAIRLINE }}>
          {t.sections.map((s, i) => (
            <div key={i} className="py-10 first:pt-0">
              <Eyebrow>{`0${i + 1}`}</Eyebrow>
              <h2 className="mt-4 text-[clamp(20px,2vw,28px)] tracking-tight font-semibold">{s.t}</h2>
              <p className="mt-4 text-[15px] leading-[1.7] text-white/70">{s.b}</p>
            </div>
          ))}
        </div>
      </RevealSection>
      <Rule />
    </V2Layout>
  );
}
